/**
 * friendlyError — converts raw Postgres/Supabase/network error strings into
 * human-readable messages safe to surface in the UI.
 */
export function friendlyError(err: unknown): string {
  if (!err) return "Something went wrong. Please try again.";
  const raw = typeof err === "string" ? err : (err as any)?.message || String(err);

  // Raw Postgres / Supabase patterns → friendly messages
  const patterns: Array<[RegExp, string]> = [
    [/duplicate key value violates unique constraint/i, "That record already exists. Please check for duplicates."],
    [/foreign key constraint/i, "This change conflicts with related data. Please refresh and try again."],
    [/row-level security/i, "You do not have permission to perform that action."],
    [/JWT expired/i, "Your session expired. Please sign in again."],
    [/invalid input syntax/i, "One of the fields has an invalid value. Please check and try again."],
    [/violates not-null constraint/i, "A required field is missing. Please complete all required fields."],
    [/violates check constraint/i, "One of the values is out of range. Please check and try again."],
    [/connection.*refused|ECONNREFUSED/i, "We could not reach the server. Please check your connection and try again."],
    [/timeout/i, "The request took too long. Please try again."],
    [/network request failed|Failed to fetch/i, "Network error. Please check your connection and try again."],
    [/401|unauthorized/i, "Your session has expired. Please sign in again."],
    [/403|forbidden/i, "You do not have permission for that action."],
    [/404|not found/i, "We could not find what you were looking for."],
    [/5\d\d/i, "The server hit an issue. Bryan Short has been notified."],
  ];

  for (const [re, friendly] of patterns) {
    if (re.test(raw)) return friendly;
  }

  // Fallback: strip stack traces, return first sentence only
  const firstSentence = raw.split(/[\.\n]/)[0].trim();
  if (firstSentence.length > 0 && firstSentence.length < 200) {
    return firstSentence + ".";
  }
  return "Something went wrong. Please try again.";
}
